import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { toast } from "sonner";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("rsmart_cart") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem("rsmart_cart", JSON.stringify(items)); }, [items]);

  const add = useCallback((product, qty = 1, opts = {}) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.product_id === product.id);
      if (ex) return prev.map((i) => i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i);
      return [...prev, { product_id: product.id, quantity: qty, name: product.name, price: product.price,
        image: product.image, unit: product.unit, mrp: product.mrp }];
    });
    if (!opts.silent) toast.success(`${product.name} added to cart`);
  }, []);
  const setQty = useCallback((pid, qty) => {
    setItems((prev) => qty <= 0 ? prev.filter((i) => i.product_id !== pid)
      : prev.map((i) => i.product_id === pid ? { ...i, quantity: qty } : i));
  }, []);
  const remove = useCallback((pid) => setItems((prev) => prev.filter((i) => i.product_id !== pid)), []);
  const clear = useCallback(() => setItems([]), []);
  const qtyOf = useCallback((pid) => items.find((i) => i.product_id === pid)?.quantity || 0, [items]);

  const value = useMemo(() => {
    const count = items.reduce((s, i) => s + i.quantity, 0);
    const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
    return { items, add, setQty, remove, clear, qtyOf, count, subtotal, open, setOpen };
  }, [items, add, setQty, remove, clear, qtyOf, open]);

  return (
    <CartCtx.Provider value={value}>
      {children}
    </CartCtx.Provider>
  );
}
